module.exports = __webpack_public_path__ + "assets/meishi.8e0f88bf.svg";